export default class FretboardService {
  _THICK = 15
  _THIN  = 3;
  _min   = -99;
  _max   = -99;

 _NUM_STRINGS=6;
  constructor(min, max) {
      this._min = min;
      this._max = max;
  }
  getEndLineThickness(val) {
      let returnVal          = (this._max-val)
      let truncatedReturnVal = Math.trunc(returnVal)
      let truncatedMin       = Math.trunc(this._min)
      if(truncatedReturnVal === 0 && truncatedMin===0) {
        return this._THICK;
      }
      return this._THIN;
  }

  getHLineThickness(val) {
      let truncatedMax = Math.trunc(this._max)

      if(val ===truncatedMax) {
          let thickness = this.getEndLineThickness(val)
          return thickness;
      }
      else  {
          return  this._THIN;
      }
  }

  getHLineColor(val) {
      if(val ===0.5) {
          return 'white';
          //return  "rgba(255, 255, 255, 0)"
      }
      else if (Number.isInteger(val)) {
          return  '#D3D3D3';
      }
      else  {
          return  '#FFFFFF';
      }
  }

  getYTicks(val) {
      if(Number.isInteger(val)) {
          return "";
      }
      else {
          let returnVal = (this._max-val)
          let truncated = Math.trunc(returnVal)


          if(this._min === 0.5 && truncated===Math.trunc(this._max)) {
              return truncated.toString()
          }
          else if(truncated===Math.trunc(this._max)) {
            return "";
          }
          let moddedVal = Math.trunc(this._min) + truncated
          return moddedVal.toString();
      }
  }

  getStringThickness(val) {
    if (Number.isInteger(val)) {
        let stringNum = this._NUM_STRINGS-val+1
        return 0.6*stringNum;
    } else  {
        return  0;
    }
  }

  getStringColor(val) {
      if (Number.isInteger(val)) {
          return  '#000000';
      }
      else  {
          return  '#FFFFFF';
      }
  }
}
